<enterprise-button-toggle [formControl]="NgControl.control"
                          [Appearance]="Appearance"
                          [Disabled]="Disabled"
                          [ErrorMessageOverride]="ErrorMessageOverride"
                          [Hidden]="Hidden"
                          [HideIfDisabled]="HideIfDisabled"
                          [Label]="Label"
                          [NeedsVerificationCallback]="NeedsVerificationCallback"
                          [PropertyTracker]="PropertyTracker"
                          [ReadOnly]="ReadOnly"
                          [ShowLabel]="ShowLabel"
                          [ToggleOptions]="ToggleOptions"
                          [ToolTip]="ToolTip"
                          (Change)="OnChange($event)">
</enterprise-button-toggle>